var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilePin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(0.376 -0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30852",
    "data-name": "Path 30852",
    d: "M12,14.17a3.865,3.865,0,1,1,3.87-3.86A3.873,3.873,0,0,1,12,14.17Zm0-6.23a2.37,2.37,0,1,0,2.37,2.37A2.375,2.375,0,0,0,12,7.94Z",
    transform: "translate(0.12 0.185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30853",
    "data-name": "Path 30853",
    d: "M12.121,23.25a6.016,6.016,0,0,1-4.183-1.708C4.95,18.637,1.648,14,2.894,8.491A9.248,9.248,0,0,1,12.121,1.25h.01A9.247,9.247,0,0,1,21.357,8.5c1.236,5.513-2.066,10.136-5.054,13.04A6.016,6.016,0,0,1,12.121,23.25Zm0-20.466A7.66,7.66,0,0,0,4.383,8.829C3.289,13.646,6.287,17.8,9,20.427a4.451,4.451,0,0,0,6.249,0c2.7-2.629,5.7-6.781,4.629-11.6A7.688,7.688,0,0,0,12.121,2.784Z",
    transform: "translate(0 0)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8475",
    "data-name": "Rectangle 8475",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePin);
export default __webpack_public_path__ + "static/media/profile-pin.deb2262de4998310296f8c5fb7e9edd5.svg";
export { ForwardRef as ReactComponent };